var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccepted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "accepted_svg__Icon_-_Accept",
    "data-name": "Icon - Accept",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "accepted_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "accepted_svg__Rectangle_429",
    "data-name": "Rectangle 429",
    fill: "none",
    stroke: "#0eb3f2",
    strokeWidth: 1.5,
    d: "M0 0h23v23H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "accepted_svg__Path_4000",
    "data-name": "Path 4000",
    d: "M16.194 8.214l-7.038 6.571-2.35-2.347",
    fill: "none",
    stroke: "#0eb3f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "accepted_svg__Group_995",
    "data-name": "Group 995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "accepted_svg__Group_994",
    "data-name": "Group 994",
    clipPath: "url(#accepted_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "accepted_svg__Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 10.796,
    cy: 10.796,
    r: 10.796,
    transform: "translate(.704 .704)",
    fill: "none",
    stroke: "#0eb3f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iSWNvbl8tX0FjY2VwdCIgZGF0YS1uYW1lPSJJY29uIC0gQWNjZXB0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMyAyMyI+CiAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aCI+CiAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfNDI5IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA0MjkiIHdpZHRoPSIyMyIgaGVpZ2h0PSIyMyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMGViM2YyIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+CiAgPHBhdGggaWQ9IlBhdGhfNDAwMCIgZGF0YS1uYW1lPSJQYXRoIDQwMDAiIGQ9Ik0xNi42MzgsOC43NSw5LjYsMTUuMzIxLDcuMjUsMTIuOTc0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC40NDQgLTAuNTM2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMGViM2YyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgPGcgaWQ9Ikdyb3VwXzk5NSIgZGF0YS1uYW1lPSJHcm91cCA5OTUiPgogICAgPGcgaWQ9Ikdyb3VwXzk5NCIgZGF0YS1uYW1lPSJHcm91cCA5OTQiIGNsaXAtcGF0aD0idXJsKCNjbGlwLXBhdGgpIj4KICAgICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8xNTYiIGRhdGEtbmFtZT0iRWxsaXBzZSAxNTYiIGN4PSIxMC43OTYiIGN5PSIxMC43OTYiIHI9IjEwLjc5NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC43MDQgMC43MDQpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwZWIzZjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgAccepted as ReactComponent };